import { FunctionComponent, useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'

import RoundedButton from 'components/RoundedButton'
import FlaredArrow from 'components/SVG/FlaredArrow'

import { useWindowSize } from 'services/hooks'

const ResponsiveSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 0;
  margin: 20px auto;
  max-width: ${props => props.theme.metrics.contentMaxWidth}px;
  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    margin: 60px auto;
    flex-direction: row;
  }
`
const TextContainer = styled.div`
  flex: 1;
  padding: 10px;
  width: 100%;
  background-color: #efefef;
  border-radius: 12px;
  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    padding: 20px;
    width: 50%;
  }
`
const BodyText = styled.p`
  font-size: 1.6em;
  line-height: 1.6em;
  margin: 20px 40px;
`
const ImageContainer = styled.div`
  flex: 1;
  padding: 10px;
  width: 100%;
  display: none;
  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    padding-left: 20px;
    width: 50%;
    display: block;
  }
  img {
    width: 100%;
    height: auto;
    border-radius: 12px;
  }
`

const ButtonWrapper = styled.div`
  padding: 20px 34px;
`

interface SavingsPromoSectionProps {
  onOpenModal: () => void
}

const SavingsPromoSection: FunctionComponent<SavingsPromoSectionProps> = ({ onOpenModal }) => {
  const theme = useContext(ThemeContext)

  const { width } = useWindowSize()

  const renderFlaredArrowIcon = () => {
    if (width && width >= theme.metrics.tablet) {
      return (
        <FlaredArrow
          fill={theme.colors.white}
          width={28}
          height={28}
        />
      )
    }

    return null
  }

  return (
    <ResponsiveSection>
      <TextContainer>
        <BodyText>
          Find out how much you could get back. Our recent buyers have received rebates ranging from
          $5,000 to over $20,000. Schedule a brief call to learn your potential savings.
        </BodyText>
        <ButtonWrapper>
          <RoundedButton
            text="Get Started"
            onClick={onOpenModal}
            fontSize={16}
            height={60}
            padding="0 40px"
            color={theme.colors.white}
            background={theme.colors.blue4}
            renderRightIcon={renderFlaredArrowIcon}
          />
        </ButtonWrapper>
      </TextContainer>
      <ImageContainer>
        <img
          src={`${process.env.CDN_BASE_URL}/q_auto/amazon/assets/1440/why_HL_PersonalizedForYou.jpg`}
          alt="Savings Promo"
        />
      </ImageContainer>
    </ResponsiveSection>
  )
}

export default SavingsPromoSection
